import * as z from 'zod';
import { wipExtractionReviewStatusSchema, extractionStatusSchema, extractionErrorTypeSchema, periodTypeSchema, financialPeriodPreparationMethodSchema } from '../../enums.mjs';
import '../../types/actor/actor.mjs';
import '../../types/address/address.mjs';
import '../../types/credit-report/company-credit-report.mjs';
import '../../types/credit-report/individual-credit-report.mjs';
import '../../types/currency/currency.mjs';
import '../../types/entityRelation/entity-relation.mjs';
import '../../types/financial-formula/adjustable-value.mjs';
import '../../types/financial-formula/adjustable-values-update.mjs';
import '../../types/financial-formula/adjustment.mjs';
import '../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../types/is-encrypted.mjs';
import '../../types/naics-codes/naics-codes.mjs';
import { isoDateTimeSchema, fileId, suretyAccountId, workInProgressScheduleExtractionId, userId, isoDateSchema } from '../../types/opaque.mjs';
import '../../types/surety/account/surety-account.types.mjs';
import '../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../types/surety/bond/surety-bond.types.mjs';
import '../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../types/surety/contract/contract-extraction-output.mjs';
import '../../types/surety/contract/contract-extraction-webhook.mjs';
import '../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import '../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../types/surety/quote/surety-quote.types.mjs';
import { wipSourceScopeSchema, wipPageNumbersSchema, WipConfidenceSignal, wipConfidenceTierSchema } from '../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import '../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../types/user/user.types.mjs';
import '../../types/utils.mjs';

var Get;
(function (Get) {
    (function (Response) {
        Response.schema = z.object({
            id: workInProgressScheduleExtractionId,
            suretyAccountId: suretyAccountId,
            fileId: fileId,
            status: extractionStatusSchema,
            reviewStatus: wipExtractionReviewStatusSchema,
            statementDate: isoDateSchema.optional(),
            sourceScope: wipSourceScopeSchema,
            preparationMethod: financialPeriodPreparationMethodSchema.optional(),
            periodType: periodTypeSchema.optional(),
            extractionConfidence: wipConfidenceTierSchema.optional(),
            errorType: extractionErrorTypeSchema.optional(),
            errorMessage: z.string().optional(),
            extractionTriggeredAt: isoDateTimeSchema.optional(),
            extractionCompletedAt: isoDateTimeSchema.optional(),
            underwriterReviewedAt: isoDateTimeSchema.optional(),
            underwriterReviewedByUserId: userId.optional(),
            signals: z.array(WipConfidenceSignal.schema).optional(),
            pageNumbers: wipPageNumbersSchema.default([]),
            createdAt: isoDateTimeSchema,
            updatedAt: isoDateTimeSchema,
        });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var Create;
(function (Create) {
    (function (Request) {
        Request.schema = z.object({ fileId });
    })(Create.Request || (Create.Request = {}));
})(Create || (Create = {}));
var Update;
(function (Update) {
    (function (Admin) {
        (function (Request) {
            Request.schema = z
                .object({
                statementDate: isoDateSchema.nullish(),
                periodType: periodTypeSchema.nullish(),
                preparationMethod: financialPeriodPreparationMethodSchema.nullish(),
                sourceScope: wipSourceScopeSchema.optional(),
            })
                .refine((data) => Object.values(data).some((v) => v !== undefined), {
                message: "At least one field is required",
            });
        })(Admin.Request || (Admin.Request = {}));
    })(Update.Admin || (Update.Admin = {}));
})(Update || (Update = {}));

export { Create, Get, Update };
